import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, switchMap } from 'rxjs/operators';
import { Store } from '@ngrx/store';

import {
  fetchAnnouncement,
  fetchAnnouncementFailure,
  fetchAnnouncementSuccess,
  setAnnouncement,
  setAnnouncementFailure,
  setDontShowAgain,
} from './announcement-dialog-actions';
import { of } from 'rxjs';
import { AnnouncementPopupsService } from '@app/shared/services/annoucement-popups.service';
import { IAnnouncementPopup } from '@app/shared/models/announcement-popups.model';
import { selectAnnouncement } from './announcement-dialog-selector';

const ANNOUNCEMENT_DONT_SHOW_KEY = 'announcement_dont_show';

@Injectable()
export class AnnouncementDialogEffects {
  constructor(
    private actions$: Actions,
    private store: Store,
    private announcementPopupsService: AnnouncementPopupsService
  ) {}

  fetchAnnouncement$ = createEffect(() =>
    this.actions$.pipe(
      ofType(fetchAnnouncement),
      switchMap(() =>
        this.announcementPopupsService.getAnnouncement().pipe(
          map((announcement: IAnnouncementPopup) => {
            return fetchAnnouncementSuccess({ announcement });
          }),
          catchError((err) => {
            return of(fetchAnnouncementFailure({ error: err.message }));
          })
        )
      )
    )
  );

  fetchAnnouncementSuccess$ = createEffect(() =>
    this.actions$.pipe(
      ofType(fetchAnnouncementSuccess),
      map((action) => {
        return setAnnouncement({
          announcement: action.announcement,
        });
      })
    )
  );

  fetchAnnouncementFailure$ = createEffect(() =>
    this.actions$.pipe(
      ofType(fetchAnnouncementFailure),
      map((action) => {
        return setAnnouncementFailure({
          error: action.error,
        });
      })
    )
  );

  setDontShowAgain$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(setDontShowAgain),
        switchMap(() => this.store.select(selectAnnouncement)),
        map((announcement) => {
          if (announcement) {
            const dontShow = localStorage.getItem(ANNOUNCEMENT_DONT_SHOW_KEY);
            const dontShowMap = dontShow ? JSON.parse(dontShow) : {};
            dontShowMap[announcement.id] = true;
            localStorage.setItem(
              ANNOUNCEMENT_DONT_SHOW_KEY,
              JSON.stringify(dontShowMap)
            );
          }
          return { type: '[Announcement Dialog] No Action' };
        })
      ),
    { dispatch: false }
  );
}
